/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import {Router} from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {SignInWidgetModule} from './pages/wpt/sign-in-widget/sign-in-widget.module';
import * as globalVars from './pages/wpt/api_settings/settings';
import { AuthService } from './pages/wpt/auth/auth.service';
// Okta Guard and Service
import { OktaAuthGuard } from './app.guard';
// import { appServ } from './app.service';

import {  
  OKTA_CONFIG,
  OktaAuthModule,
  OktaAuthService
} from '@okta/okta-angular';

const oktaConfig = {
  issuer: globalVars.baseURLOkta + '/oauth2/default',
  clientId: globalVars.clientId, 
  redirectUri: globalVars.redirectUri,
  pkce: true,
  // onAuthRequired: onAuthRequired,
  tokenManager: {
    secure: true,
    expireEarlySeconds: 120
  },
  // Handle session expiration / token renew failure
  onSessionExpired: function() {
    //let oktaServ:OktaAuthService;
    localStorage.clear();
    location.reload();
    // NOTE logout might need to be relooked at using geoauth service
  }
}
// import {
//   OktaCallbackComponent,
// } from '@okta/okta-angular';

import { OktaCallbackComponent } from './callback/callback.component';

@NgModule({
  declarations: [
    AppComponent, 
    OktaCallbackComponent, 
  ],
  imports: [
    OktaAuthModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    SignInWidgetModule,
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
  ],
  bootstrap: [
    AppComponent,
  ],
  providers: [
    OktaAuthGuard,
    { provide: OKTA_CONFIG, useValue: oktaConfig },
    { provide: APP_BASE_HREF, useValue: '/' },
  ],
})
export class AppModule {
}
